import { useMutation } from 'react-query';

import { setAcrossVersionHashCodeConfig as mutationFn } from 'api/endPoints/setAcrossVersionHashCodeConfig';

export type AcrossVersionHashCodeConfig = {
    projectId: number;
    isSetActivityId: boolean;
    isSetActivityType: boolean;
    isSetFullPathParentNames: boolean;
    isSetName: boolean;
    isSetParentName: boolean;
    isSetUuid: boolean;
    isSetWbsLevel: boolean;
};

export const useMutationSetAcrossVersionHashCodeConfig = () => {
    return useMutation<unknown, QueryError, AcrossVersionHashCodeConfig>((params: AcrossVersionHashCodeConfig) =>
        mutationFn(params),
    );
};
